import { render, staticRenderFns } from "./sales-plan-publish-confirmation.vue?vue&type=template&id=5a2a44bf&scoped=true&"
import script from "./sales-plan-publish-confirmation.vue?vue&type=script&lang=js&"
export * from "./sales-plan-publish-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./sales-plan-publish-confirmation.vue?vue&type=style&index=0&id=5a2a44bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a44bf",
  null
  
)

export default component.exports